class PaginationTheme extends HTMLElement {
  constructor() {
    super();

    this.progress = this.querySelector(".pagination-progress");
    this.button = this.querySelector(".load-more");
    
    // Auto-detect if current page is product or blog
    this.isProductPage = document.getElementById("product-grid") !== null;
    this.isBlogPage = document.getElementById("article-grid") !== null;
    
    // Set container based on page type
    if (this.isProductPage) {
      this.grid = document.getElementById("product-grid");
      this.containerSelector = "#ProductGridContainer";
      this.itemSelector = "product-card";
    } else if (this.isBlogPage) {
      this.grid = document.getElementById("article-grid");
      this.containerSelector = "#BlogGridContainer";
      this.itemSelector = ".cmb-article-grid__item";
    }else {
      // No supported grid found - pagination not applicable
      console.warn('PaginationTheme: No product-grid or article-grid found');
      return;
    }
    
    this.total_page = this.dataset.totalPage;    
    this.i = this.dataset.currentPage ? parseInt(this.dataset.currentPage) : 1;
    this.current_page = this.dataset.currentPage ? parseInt(this.dataset.currentPage) : 1;
    
    this.renderItemCount();
    this.loadMore()
    
  }

  renderItemCount(){
    // Select correct elements based on page type
    const items = document.querySelectorAll(`${this.containerSelector} ${this.itemSelector}`);
    this.progress.querySelector(".num").innerText = items.length;
    this.progress.style.setProperty("--current-progress", items.length * 100.0/this.progress.dataset.totalNum+"%");

    if(items.length == this.progress.dataset.totalNum){
      this.classList.add("no-more")
    }
  }

  addUrlParam(search, key) {
      var newParam = key + '=' + this.dataset.currentPage,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }
      this.current_page = newParam;
      return params;
    }
  loadItems() {
    if (this.getAttribute('loading')) {
      return;
    }
    this.i = parseInt(this.dataset.currentPage);
    this.i++;
    this.dataset.currentPage = this.i;
    let url = document.location.pathname + this.addUrlParam(document.location.search, 'page');
    // history.pushState({ "page": this.dataset.currentPage }, '', `${url}`);
    // if(document.querySelector(".cust-facets input[name='page']")){
    //   document.querySelector(".cust-facets input[name='page']").value = this.dataset.currentPage
    // }
    this.setAttribute('loading', true);
    
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderItems(html, url);
      });
  }

  renderItems(html, url) {
    // Select correct grid ID based on page type
    const gridId = this.isProductPage ? 'product-grid' : 'article-grid';
    const grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById(gridId);
    
    if (grid_to_replace) {
      this.grid.insertAdjacentHTML('beforeend', grid_to_replace.innerHTML);
    }
    
    this.renderItemCount();
    this.removeAttribute('loading');
    
    // Product page: reinitialize Klaviyo
    if (this.isProductPage && typeof klaviyoBIS !== 'undefined') {
      klaviyoBIS.init();
    }
  }
  loadMore() {
      this.button.addEventListener('click', () => {
        this.loadItems();
        this.blur();
        return false;
      });
    }
  
  initEventListener() {
    
  }

}

customElements.define('pagination-theme', PaginationTheme);